import { cx } from "@emotion/css";
import { useState } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import routing from "routing";
import Navbar from "src/components/Menu/Navbar";
import { CoursesList } from "src/components/NewComponents/Courses/CoursesList/CoursesList";
import GenerateDeck from "src/components/NewComponents/Creator/NewDeckCreator";
import { TawkMessengerProvider } from "src/components/TawkMessenger/TawkMessengerProvider";
import ExamHome from "src/containers/ExamHome";
import { ExamsList } from "src/containers/Exams/ExamsList";
import { ContainerQueryProvider } from "src/containers/Layouts/AppContentContext";
import AccessDenied from "src/containers/NewContainers/AccessDenied";
import Article from "src/containers/NewContainers/Article";
import CoursesPicker from "src/containers/NewContainers/CoursesPicker";
import { CourseTemplatesPickerContainer } from "src/containers/NewContainers/CoursesTemplatesList";
import { CourseTypePickerContainer } from "src/containers/NewContainers/CourseTypePicker";
import { CourseView } from "src/containers/NewContainers/CourseView";
import ExamsPicker from "src/containers/NewContainers/ExamsPicker";
import FlashcardApp from "src/containers/NewContainers/FlashcardsApp";
import { FlashcardsDeckChoiceContainer } from "src/containers/NewContainers/FlashcardsDeckChoice";
import { FlashcardsDeckImportContainer } from "src/containers/NewContainers/FlashcardsDeckImport";
import Flashcards from "src/containers/NewContainers/FlashcardsPicker";
import { FoldersList } from "src/containers/NewContainers/FoldersList/FoldersList";
import { FolderView } from "src/containers/NewContainers/FolderView/FolderView";
import GenerateCourse from "src/containers/NewContainers/GenerateCourse";
import GenerateExam from "src/containers/NewContainers/GenerateExam";
import { NotePreview } from "src/containers/NewContainers/NoteView/NotePreview";
import { NoteView } from "src/containers/NewContainers/NoteView/NoteView";
import UserDecks from "src/containers/NewContainers/UserDecks";
import { hasLimitedAccess } from "src/helpers/getPermissions";
import isMobile from "src/helpers/isMobile";
import { isFaqEnabled } from "src/hooks/useAppConfig";

import BottomNavigation from "../components/Menu/BottomNavigation";
import { FullHeightContainer } from "../components/NewComponents/Default/FullHeightContainer";
import Search from "../components/NewComponents/Search";
import { RedirectQuestions } from "../components/NewComponents/Search/Redirect";
import Profile from "../components/Profile/Profile";
import { isLdek, isLek } from "../helpers/services";
import { ExamTypePickerContainer } from "./NewContainers/ExamsTypePicker";
import { Guide } from "./NewContainers/Guide";
import { UserProfile } from "./NewContainers/UserProfile";

function App() {
	const [open, setOpen] = useState(!isMobile());

	const renderRouter = () => {
		if (hasLimitedAccess()) {
			return (
				<Switch>
					<Route path={routing.paths.createExam} component={GenerateExam} />
					<Route path={routing.paths.examsList} component={ExamsList} />
					<Route path={routing.paths.exams} component={ExamsPicker} />
					<Route path={routing.paths.userProfile} component={Profile} />
					<Route
						path={routing.paths.redirectSearchQuestion}
						component={AccessDenied}
					/>
					<Route path={routing.paths.searchQuestion} component={AccessDenied} />
					<Route
						path={routing.paths.pickFlashcardsDeckChoice}
						component={AccessDenied}
					/>
					<Route path={routing.paths.userDecks} component={AccessDenied} />
					<Route path={routing.paths.createDeck} component={AccessDenied} />
					<Route path={routing.paths.importDecks} component={AccessDenied} />
					<Route path={routing.paths.flashcardsApp} component={AccessDenied} />
					<Route path={routing.paths.flashcards} component={AccessDenied} />
					<Route path={routing.paths.createCourse} component={AccessDenied} />
					<Route path={routing.paths.userCourses} component={AccessDenied} />
					<Route
						exact
						path={routing.paths.foldersList}
						component={AccessDenied}
					/>
					<Route path={routing.paths.previewNote} component={AccessDenied} />
					<Route path={routing.paths.editNote} component={AccessDenied} />
					<Route path={routing.paths.createNote} component={AccessDenied} />
					<Route path={routing.paths.folder} component={AccessDenied} />
					<Route path={routing.paths.course} component={AccessDenied} />
					<Route path={routing.paths.coursesList} component={AccessDenied} />
					{(isLek() || isLdek()) && (
						<Route path={routing.paths.article} component={AccessDenied} />
					)}
					{(isLek() || isLdek()) && (
						<Redirect
							from={routing.paths.articlesLegacy}
							to={routing.paths.knowledgeBase}
						/>
					)}
					{isFaqEnabled() && (
						<Route path={routing.paths.guide} component={AccessDenied} />
					)}
					<Route path={routing.paths.home} component={ExamHome} />
				</Switch>
			);
		}

		return (
			<Switch>
				<Route
					path={routing.paths.pickExamType}
					component={ExamTypePickerContainer}
				/>
				<Route
					path={routing.paths.pickCourseType}
					component={CourseTypePickerContainer}
				/>
				<Route
					path={routing.paths.courseTemplates}
					component={CourseTemplatesPickerContainer}
				/>
				<Route path={routing.paths.createExam} component={GenerateExam} />
				<Route path={routing.paths.examsList} component={ExamsList} />
				<Route path={routing.paths.exams} component={ExamsPicker} />
				<Route path={routing.paths.userProfile} component={UserProfile} />
				<Route
					path={routing.paths.redirectSearchQuestion}
					component={RedirectQuestions}
				/>
				<Route path={routing.paths.searchQuestion} component={Search} />
				<Route
					path={routing.paths.pickFlashcardsDeckChoice}
					component={FlashcardsDeckChoiceContainer}
				/>
				<Route path={routing.paths.userDecks} component={UserDecks} />
				<Route path={routing.paths.createDeck} component={GenerateDeck} />
				<Route
					path={routing.paths.importDecks}
					component={FlashcardsDeckImportContainer}
				/>
				<Route path={routing.paths.flashcardsApp} component={FlashcardApp} />
				<Route path={routing.paths.flashcards} component={Flashcards} />
				<Route path={routing.paths.createCourse} component={GenerateCourse} />
				<Route path={routing.paths.userCourses} component={CoursesList} />
				<Route exact path={routing.paths.foldersList} component={FoldersList} />
				<Route path={routing.paths.previewNote} component={NotePreview} />
				<Route path={routing.paths.editNote} component={NoteView} />
				<Route path={routing.paths.createNote} component={NoteView} />
				<Route path={routing.paths.folder} component={FolderView} />
				<Route path={routing.paths.course} component={CourseView} />
				<Route path={routing.paths.coursesList} component={CoursesPicker} />
				{(isLek() || isLdek()) && (
					<Route path={routing.paths.article} component={Article} />
				)}
				{(isLek() || isLdek()) && (
					<Redirect
						from={routing.paths.articlesLegacy}
						to={routing.paths.knowledgeBase}
					/>
				)}
				{isFaqEnabled() && (
					<Route path={routing.paths.guide} component={Guide} />
				)}
				<Route path={routing.paths.home} component={ExamHome} />
			</Switch>
		);
	};

	const renderMainRoutes = () => {
		return (
			<div className="flex h-100">
				<Navbar open={open} setOpen={setOpen} />
				<ContainerQueryProvider>
					<div className={cx("app-content")} id="content">
						<div className="flex-1 h-100">{renderRouter()}</div>
					</div>
				</ContainerQueryProvider>
				<BottomNavigation />
			</div>
		);
	};

	return (
		<TawkMessengerProvider>
			<FullHeightContainer className="w-100vw">
				{renderMainRoutes()}
			</FullHeightContainer>
		</TawkMessengerProvider>
	);
}

export default App;
